// @flow
import React from 'react';
import { useEffect, useCallback } from 'react';
//$FlowFixMe
import { makeStyles } from '@material-ui/core/styles';

import Box from 'bizom-mui/lib/Box';
import TextLink from 'bizom-mui/lib/TextLink';

import Card from '@material-ui/core/Card';
import Modal from '@material-ui/core/Modal';
import Slide from '@material-ui/core/Slide';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';
import CardContent from '@material-ui/core/CardContent';

import {
  ENTER_MANUALLY,
  LOOKING_FOR_VERIFICATION_CODE,
} from 'constants/strings';
import CircularSpinner from './CircularSpinner';

type Props = {
  open: boolean,
  onClose: () => void,
  onSetOTP: (otp: string) => void,
  onSubmit: () => void,
};

const useStyles = makeStyles(({ typography, spacing, palette }) => ({
  card: {
    position: 'fixed',
    borderRadius: 0,
    outline: 'none',
    bottom: 0,
    width: '100%',
    maxHeight: '90%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}));

const OTPAutoReadDialog = ({ open, onClose, onSetOTP, onSubmit }: Props) => {
  const classes = useStyles({});

  const onSMSArrive = useCallback(
    (args) => {
      console.log('onSMSArrive: args.message --- ', args.message);
      const code =
        args && args.message && typeof args.message === 'string'
          ? args.message.substr(4, 6)
          : null;
      if (code && code.length === 6) {
        console.log('onSMSArrive: code --- ', code);
        onSetOTP(code);
        onSubmit();
      } else {
        console.log('onSMSArrive: invalid code --- ', code);
        onClose();
      }
    },
    [onClose, onSetOTP, onSubmit]
  );

  const onDeviceReady = useCallback(() => {
    console.log('OTPAutoReadDialog: deviceready....');

    /* Initialize plugin */
    if (typeof window.SMSRetriever === 'undefined') {
      console.warn('OTPAutoReadDialog: (SMSRetriever): plugin not present');
      onClose();
    } else {
      console.log('OTPAutoReadDialog: ADDED EVENT onSMSArrive....');
      //$FlowFixMe
      document.addEventListener('onSMSArrive', onSMSArrive, false);

      // Bind startWatch method
      setTimeout(function () {
        window.SMSRetriever.startWatch(
          function (msg) {
            console.log('OTPAutoReadDialog (startWatch): success --- ', msg);
          },
          function (err) {
            console.error('OTPAutoReadDialog (startWatch): err --- ', err);
            onClose();
          }
        );
      }, 100);
    }
  }, [onClose, onSMSArrive]);

  useEffect(() => {
    document.addEventListener('deviceready', onDeviceReady.bind(this), false);

    return () => {
      //$FlowFixMe
      document.removeEventListener('onSMSArrive', onSMSArrive, false);
    };
  }, [onDeviceReady, onSMSArrive]);

  const handleClose = () => onClose();

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="find-my-outlets-modal-title"
        aria-describedby="find-my-outlets-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        disableBackdropClick
        disableEscapeKeyDown
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide in={open} direction="up" mountOnEnter unmountOnExit>
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              <Typography display="block" variant="body1" gutterBottom>
                {LOOKING_FOR_VERIFICATION_CODE}
              </Typography>
              <Box mt={1}>
                <CircularSpinner />
              </Box>
              <Box mt={3}>
                <TextLink
                  id="link-contact-support"
                  color="primary"
                  onClick={handleClose}
                >
                  {ENTER_MANUALLY}
                </TextLink>
              </Box>
            </CardContent>
          </Card>
        </Slide>
      </Modal>
    </React.Fragment>
  );
};

const isSame = (prevProps, nextProps) => prevProps.open === nextProps.open;

export default React.memo(OTPAutoReadDialog, isSame);
